<template>
  <qx-card-form title="保险信息" v-show="showComponent" :defaultContentShow="false">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
import {addMonthForDate} from '@qx/utils';

export default {
  data () {
    return {
      showComponent: true,
      otherFormData: {
        earlyWarningDay: '',
        busiEarlyWarningDay: '',
      },
      baseForm: {
        inline: true,
        form: [
          {
            label: '交强险到期日',
            value: 'insuranceTimeEnd',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
            disabled: true,
          },
          {
            label: '预警天数',
            value: 'earlyWarningDay',
            type: 'input',
            hide: true,
          },
          {
            label: '商业险到期日',
            value: 'busiInsuranceTimeEnd',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
            disabled: true,
          },
          {
            label: '意外险到期日',
            value: 'accidentInsuranceTimeEnd',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
            disabled: true,
          },
          {
            label: '超赔险到期日',
            value: 'excessInsuranceTimeEnd',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
            disabled: true,
          },
          {
            label: '其他险到期日',
            value: 'otherInsuranceTimeEnd',
            type: 'date',
            attr: {
              time: '00:00:00',
            },
            disabled: true,
          },
        ],
      },
    };
  },
  methods: {
    setList (values) {
      this.otherFormData.earlyWarningDay = values[0];
      this.otherFormData.busiEarlyWarningDay = values[1];
    },
    async getDataTest () {
      this.sub();
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          insuranceTimeEnd: this.formatDate(formData.insuranceTimeEnd),
          busiInsuranceTimeEnd: this.formatDate(formData.busiInsuranceTimeEnd),
          accidentInsuranceTimeEnd: this.formatDate(formData.accidentInsuranceTimeEnd),
          excessInsuranceTimeEnd: this.formatDate(formData.excessInsuranceTimeEnd),
          otherInsuranceTimeEnd: this.formatDate(formData.otherInsuranceTimeEnd),
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      const formData = await this.handleSubData();
      // console.log('保险信息提交参数', formData);
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      this.resetBaseForm();
      this.$refs.baseForm.setVal(data);
      this.setFormValFromData(this.otherFormData, data);
    },
    // 修改车辆种类为【临时外调车时】
    changeToOutward () {
      // 切换成临时外调车
      this.showComponent = false;
    },
    resetToNormal () {
      // 恢复成正常模式
      this.showComponent = true;
    },
    resetBaseForm () {
      let showComponent = true;
      if (this.$route.query.type === 'outward') {
        showComponent = false;
      }
      this.showComponent = showComponent;
    },
    formChange (vehicleInfo) {
      this.resetBaseForm();
      if (this.$route.query.type === 'my') {
        if (vehicleInfo) {
          if (!this.$route.query.id) {
            this.showComponent = false;
          }
        } else {
          this.showComponent = true;
        }
      }
    },
    receivedData (vehicleInfo) {
      this.formChange(vehicleInfo);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
